import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import Safety from "../pages/safety/page";
import Contact from "../pages/contact/page";
import Disclaimer from "../pages/disclaimer/page";
import ArticleLegit from "../pages/articles/legit/page";
import ArticleShipping from "../pages/articles/shipping/page";
import ArticleCoupon from "../pages/articles/coupon/page";
import ArticleReview from "../pages/articles/review/page";
import ArticleQC from "../pages/articles/qc/page";
import PillarArticle from "../components/feature/PillarArticle";
import RichArticlePage from "../components/feature/RichArticlePage";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/safety",
    element: <Safety />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/disclaimer",
    element: <Disclaimer />,
  },
  {
    path: "/allchinabuy-spreadsheet-complete-guide",
    element: <RichArticlePage slug="allchinabuy-spreadsheet-complete-guide" />,
  },
  {
    path: "/is-allchinabuy-legit",
    element: <ArticleLegit />,
  },
  {
    path: "/allchinabuy-shipping-cost-guide",
    element: <ArticleShipping />,
  },
  {
    path: "/allchinabuy-coupon-guide",
    element: <ArticleCoupon />,
  },
  {
    path: "/allchinabuy-review",
    element: <ArticleReview />,
  },
  {
    path: "/allchinabuy-qc-guide",
    element: <ArticleQC />,
  },
  {
    path: "/how-to-use-allchinabuy-spreadsheet",
    element: <PillarArticle slug="how-to-use-allchinabuy-spreadsheet" />,
  },
  {
    path: "/allchinabuy-seller-guide",
    element: <PillarArticle slug="allchinabuy-seller-guide" />,
  },
  {
    path: "/allchinabuy-beginner-guide",
    element: <PillarArticle slug="allchinabuy-beginner-guide" />,
  },
  {
    path: "/best-allchinabuy-finds",
    element: <PillarArticle slug="best-allchinabuy-finds" />,
  },
  {
    path: "/allchinabuy-warehouse-guide",
    element: <PillarArticle slug="allchinabuy-warehouse-guide" />,
  },
  {
    path: "/allchinabuy-alternatives",
    element: <PillarArticle slug="allchinabuy-alternatives" />,
  },
  {
    path: "/allchinabuy-payment-refund-guide",
    element: <PillarArticle slug="allchinabuy-payment-refund-guide" />,
  },
  {
    path: "/allchinabuy-tracking-guide",
    element: <PillarArticle slug="allchinabuy-tracking-guide" />,
  },
  {
    path: "/allchinabuy-qc-checklist",
    element: <PillarArticle slug="allchinabuy-qc-checklist" />,
  },
  {
    path: "/best-allchinabuy-sellers",
    element: <PillarArticle slug="best-allchinabuy-sellers" />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;